class DismissedBannersService {
  private STORAGE_KEY_PREFIX = 'dismissedBanner.'

  // Per contractor, so a shared browser still shows the banner to the next contractor
  private getStorageKey(configKey: string, driverId: string): string {
    return `${this.STORAGE_KEY_PREFIX}${configKey}.${driverId}`
  }

  public getDismissedBannerId(configKey: string, driverId: string): string | null {
    try {
      return localStorage.getItem(this.getStorageKey(configKey, driverId))
    } catch {
      // Storage can be blocked (private mode)
      return null
    }
  }

  public setDismissedBannerId(configKey: string, driverId: string, bannerId: string) {
    try {
      localStorage.setItem(this.getStorageKey(configKey, driverId), bannerId)
    } catch {
      // Storage can be blocked (private mode)
    }
  }
}

export const dismissedBannersService = new DismissedBannersService()
